// src/components/common/CookieConsentBanner.tsx
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'cookie-consent';

export function CookieConsentBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = (consentLevel: 'necessary' | 'all') => {
        localStorage.setItem(COOKIE_CONSENT_KEY, consentLevel);
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    // 👇 A MÁGICA ACONTECE NESSAS CLASSES DE ESTILO 👇
    return (
        // 'fixed' tira o banner do fluxo normal e o fixa na tela
        // 'inset-x-0 bottom-4' o centraliza na horizontal e o afasta um pouco do rodapé
        // 'z-50' garante que ele fique por cima de outros elementos
        <div className="fixed inset-x-0 bottom-4 z-50 px-4">
            <div className="bg-white border border-border-color rounded-lg shadow-2xl max-w-5xl mx-auto p-6 flex flex-col md:flex-row items-center gap-6">

                <p className="text-sm text-text-secondary flex-grow text-center md:text-left">
                    Nós usamos cookies para melhorar sua experiência em nosso site e para análises. Ao continuar, você concorda com nosso uso de cookies. Saiba mais em nossa{' '}
                    <Link to="/privacidade" className="font-semibold text-brand-blue hover:underline">
                        Política de Privacidade
                    </Link>.
                </p>

                <div className="flex-shrink-0 flex items-center gap-3 w-full md:w-auto">
                    <button
                        onClick={() => handleAccept('necessary')}
                        className="w-full md:w-auto px-5 py-2.5 text-sm font-semibold text-text-secondary bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                        Apenas Necessários
                    </button>
                    <button
                        onClick={() => handleAccept('all')}
                        className="w-full md:w-auto px-5 py-2.5 text-sm font-semibold text-white bg-brand-blue rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        Aceitar Todos
                    </button>
                </div>
            </div>
        </div>
    );
}